export default {
    id: 'Jahr',
    is_active: 'Aktiv',
    is_active_help_text: 'Aktiv bedeutet, dass das Jahr standardmäßig bei allen Seiten ausgewählt ist. Es kann nur ein Jahr aktiv sein.',
    is_visible: 'Sichtbar',
    is_visible_help_text: 'Sichtbar bedeutet, dass das Jahr in den Jahres-Auswahlboxen angezeigt wird.',
    total_funding: 'Gesamtzuwendung',

    useDataFromPreviousYear: 'Jahresdaten vom Vorjahr übernehmen',

    saveSuccess: 'Jahr wurde erfolgreich gespeichert.',
    deleteYear: 'Jahr löschen',
    deleteYearText: 'Möchten Sie dieses Jahr wirklich löschen?',
    deleteYearSuccess: 'Jahr wurde erfolgreich gelöscht.',
    deleteYearError: 'Das Jahr konnte nicht gelöscht werden.',

    menu: {
        yearBaseData: 'Grunddaten',
        yearData: 'Jahresdaten',
        yearInterviews: 'Gesprächstermine',
    },

    table: {
        id: 'Jahr',
        is_active: 'Aktiv',
        is_visible: 'Sichtbar',
        process_creation_enabled_areas: 'Neue Maßnahmen erlaubt',
        total_funding: 'Gesamtzuwendung',
    },

    fundingAreas: {
        title: 'Neue Maßnahmen erlauben',
        description: 'Legt pro Förderbereich fest, ob für dieses Jahr neue Maßnahmen angelegt werden dürfen. Formulare in bestehenden Maßnahmen, z. B. Verwendungsnachweise, können unabhängig davon weiter hinzugefügt werden.',
        fundingArea: 'Förderbereich',
        processCreationEnabled: 'Neue Maßnahmen erlaubt',
    },

    yearData: {
        editFundingProgram: 'Bearbeiten',
        editYearData: '{fundingProgram} bearbeiten',
        apply: 'Änderungen übernehmen'

    }
}